export enum SitePages {
    about = "about",
    terms = "terms",
    privacy = "privacy",
    contact = "contact"
}